export default [
    {
        name: "adventurer",
        label: "Adventurer",
        author: "Lisa Wischofsky",
        authorUrl: "https://www.instagram.com/lischi_art/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/1184595184137881796",
    },
    {
        name: "adventurerNeutral",
        label: "Adventurer Neutral",
        author: "Lisa Wischofsky",
        authorUrl: "https://www.instagram.com/lischi_art/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/1184595184137881796",
    },
    {
        name: "bigEars",
        label: "Big Ears",
        author: "The Visual Team",
        authorUrl: "https://thevisual.team/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/986078800058673824",
    },
    {
        name: "bigEarsNeutral",
        label: "Big Ears Neutral",
        author: "The Visual Team",
        authorUrl: "https://thevisual.team/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/986078800058673824",
    },
    {
        name: "bigSmile",
        label: "Big Smile",
        author: "Ashley Seo",
        authorUrl: "http://www.ashleyseo.com/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/881358461963645496",
    },
    {
        name: "croodles",
        label: "Croodles",
        author: "vijay verma",
        authorUrl: "https://vjy.me/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/966199982810283152",
    },
    {
        name: "croodlesNeutral",
        label: "Croodles Neutral",
        author: "vijay verma",
        authorUrl: "https://vjy.me/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/966199982810283152",
    },
    {
        name: "dylan",
        label: "Dylan",
        author: "Natalia Spivak",
        authorUrl: "https://nataspvk.tilda.ws/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/1356575240759683500",
    },
    {
        name: "funEmoji",
        label: "Fun Emoji",
        author: "Davis Uche",
        authorUrl: "https://www.instagram.com/davedirect3/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/968125295144990435",
    },
    {
        name: "glass",
        label: "Glass",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.dicebear.com/",
    },
    {
        name: "icons",
        label: "Icons",
        author: "Bootstrap Icons",
        authorUrl: "https://getbootstrap.com/",
        license: "MIT",
        licenseUrl: "https://github.com/twbs/icons/blob/main/LICENSE",
        source: "https://github.com/twbs/icons",
    },
    {
        name: "identicon",
        label: "Identicon",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.dicebear.com/",
    },
    {
        name: "initials",
        label: "Initials",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://github.com/dicebear/dicebear",
    },
    {
        name: "lorelei",
        label: "Lorelei",
        author: "Lisa Wischofsky",
        authorUrl: "https://www.instagram.com/lischi_art/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
    },
    {
        name: "loreleiNeutral",
        label: "Lorelei Neutral",
        author: "Lisa Wischofsky",
        authorUrl: "https://www.instagram.com/lischi_art/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.figma.com/community/file/1198749693280469639",
    },
    {
        name: "micah",
        label: "Micah",
        author: "Micah Lanier",
        authorUrl: "https://dribbble.com/micahlanier",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/829741575478342595",
    },
    {
        name: "miniavs",
        label: "Mini Avatars",
        author: "Webpixels",
        authorUrl: "https://webpixels.io/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://www.figma.com/community/file/923211396597067458",
    },
    {
        name: "notionists",
        label: "Notionists",
        author: "Zoish",
        authorUrl: "https://bio.link/heyzoish",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://heyzoish.gumroad.com/l/notionists",
    },
    {
        name: "notionistsNeutral",
        label: "Notionists Neutral",
        author: "Zoish",
        authorUrl: "https://bio.link/heyzoish",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://heyzoish.gumroad.com/l/notionists",
    },
    {
        name: "openPeeps",
        label: "Open Peeps",
        author: "Pablo Stanley",
        authorUrl: "https://twitter.com/pablostanley",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.openpeeps.com/",
    },
    {
        name: "personas",
        label: "Personas",
        author: "Draftbit - draftbit.com",
        authorUrl: "https://draftbit.com/",
        license: "CC BY 4.0",
        licenseUrl: "https://creativecommons.org/licenses/by/4.0/",
        source: "https://personas.draftbit.com/",
    },
    {
        name: "pixelArt",
        label: "Pixel Art",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.figma.com/community/file/1198754108850888330",
    },
    {
        name: "pixelArtNeutral",
        label: "Pixel Art Neutral",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.figma.com/community/file/1198754108850888330",
    },
    {
        name: "rings",
        label: "Rings",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.dicebear.com/",
    },
    {
        name: "shapes",
        label: "Shapes",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.dicebear.com/",
    },
    {
        name: "thumbs",
        label: "Thumbs",
        author: "DiceBear",
        authorUrl: "https://www.dicebear.com/",
        license: "CC0 1.0",
        licenseUrl: "https://creativecommons.org/publicdomain/zero/1.0/",
        source: "https://www.dicebear.com/",
    },
];
